import Vue from 'vue'

const drag = Vue.directive('drag', {
  bind: (el, binding, vnode) => {
    setTimeout(() => {
      //开始拖动时间和结束拖动时间比较
      let firstTime = '', lastTime = '';
      /**
       * 1.在元素已经挂载在页面上时进行判断
       * 2.鼠标点击事件事先定义标记，区分点击和拖动
       * 3.计算鼠标相对元素位置
       * 4.鼠标拖动时，计算拖动后相对元素的位置
       * 5.鼠标放开时，移除相关事件监听器
       */
      vnode.context.$nextTick(() => {
        /* 做一个提示动画 */
        Vue.prototype.$requestAnimation(el)
        el.onmousedown = (e) => {
          el.setAttribute('data-flag', false)
          firstTime = new Date().getTime();
          let divx = e.clientX - el.offsetLeft
          document.onmousemove = (e) => {
            let l = e.clientX - divx;
            //子元素宽度小于父元素宽度时，不允许拖动, 否则允许拖动
            if (el.parentNode.clientWidth >= el.clientWidth) {
              return false
            } else {
              if (l > 0) {
                el.style.left = 0
              } else if (l <= el.parentNode.clientWidth - el.clientWidth) {
                el.style.left = `${el.parentNode.clientWidth - el.clientWidth - 20}px`
              } else {
                el.style.left = `${l}px`
              }
            }
          }
          document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
            // onmouseup 时的时间，并计算差值
            lastTime = new Date().getTime();
            if ((lastTime - firstTime) < 200) {
              el.setAttribute('data-flag', true)
            }
          }
        }
      })
    }, 0)
  }
})

Vue.prototype.$requestAnimation = (el) => {
  el.style.left = `-${el.clientWidth}px`
  function run() {
    let left = Number(el.style.left.replace(/[^\d|^.|^-]/g, '')) + 20
    if (Number(left) < 0) {
      el.style.left = `${Number(left)}px`
      requestAnimationFrame(run)
    } else {
      el.style.left = `0px`
    }
  }
  requestAnimationFrame(run)
}


export { drag }